module.exports = __webpack_public_path__ + "img/asanka-smc.7fb6715c.jpg";